import { render, staticRenderFns } from "./viewData.vue?vue&type=template&id=254b0788&scoped=true"
import script from "./viewData.vue?vue&type=script&lang=js"
export * from "./viewData.vue?vue&type=script&lang=js"
import style0 from "./viewData.vue?vue&type=style&index=0&id=254b0788&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254b0788",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('254b0788')) {
      api.createRecord('254b0788', component.options)
    } else {
      api.reload('254b0788', component.options)
    }
    module.hot.accept("./viewData.vue?vue&type=template&id=254b0788&scoped=true", function () {
      api.rerender('254b0788', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/import/general/components/viewData.vue"
export default component.exports